import { html } from 'lit';
import type { TefComsCancelButton } from '@src/components/TefComsCancelButton.js';

// a cancel button that triggers an event
export const tefComsCancelButton = function render(this: TefComsCancelButton, variant: string) {
  return html`
    <one-button variant="${variant}" size="medium" @click=${this.handleClick}>
      ${this.text}
    </one-button>
  `;
};
